/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { encodeBase64 } from "../../utils/utilityFunctions"
import { CALL_API } from "../middleware"
import {
    ADD_ORDER_ENTRY,
    ADD_ORDER_ENTRY_SUCCESS,
    AddOrderEntryRequestBody,
    AddOrderEntryResponseBody,
    APPROVAL_TYPE_FILTER,
    APPROVAL_TYPE_FILTER_SUCCESS,
    GET_BANK_BALANCE,
    GET_BANK_BALANCE_SUCCESS,
    GET_BONDS_DP_ID,
    GET_BONDS_DP_ID_SUCCESS,
    GET_BROKER_BANK_DETAILS,
    GET_BROKER_BANK_DETAILS_SUCCESS,
    GET_COUNTER_PARTY_LIST,
    GET_COUNTER_PARTY_LIST_SUCCESS,
    GET_DEMAT_DETAILS,
    GET_DEMAT_DETAILS_SUCCESS,
    GET_NON_MF_BROKERS_LIST,
    GET_NON_MF_BROKERS_LIST_SUCCESS,
    GET_NON_MF_HOLDINGS_LIST,
    GET_NON_MF_HOLDINGS_LIST_SUCCESS,
    GET_NON_MF_SECURITIES_LIST,
    GET_NON_MF_SECURITIES_LIST_SUCCESS,
    GET_ORDER_ENTRY_BANKS_LIST,
    GET_ORDER_ENTRY_BANKS_LIST_SUCCESS,
    GET_ORDER_ENTRY_INVESTOR_LIST,
    GET_ORDER_ENTRY_INVESTOR_LIST_SUCCESS,
    GET_SETTLEMENT_DETAILS,
    GET_SETTLEMENT_DETAILS_SUCCESS,
    GET_TRADE_CALCULATION,
    GET_TRADE_CALCULATION_SUCCESS,
    GetBankBalanceRequestBody,
    GetBankBalanceResponseBody,
    GetBondsDpIdRequestBody,
    GetBondsDpIdResponseBody,
    GetBrokerBankDetailsRequestBody,
    GetBrokerBankDetailsResponseBody,
    GetCounterPartyListRequestBody,
    GetCounterPartyListResponseBody,
    GetDematDetailsRequestBody,
    GetDematDetailsResponseBody,
    GetNonMfBrokersListRequestBody,
    GetNonMfBrokersListResponseBody,
    GetNonMfHoldingsListRequestBody,
    GetNonMfSecuritiesListRequestBody,
    GetOrderEntryBanksListRequestBody,
    GetOrderEntryBanksListResponseBody,
    GetOrderEntryInvestorListRequestBody,
    GetOrderEntryInvestorListResponseBody,
    GetSettlementDetailsRequestBody,
    GetSettlementDetailsResponseBody,
    GetTradeCalculationRequestBody,
    GetTradeCalculationResponseBody,
    ORDER_HISTORY_LIST,
    ORDER_HISTORY_LIST_SUCCESS,
    ORDER_STATUS,
    ORDER_STATUS_SUCCESS,
    ORDER_SUMMARY,
    ORDER_SUMMARY_SUCCESS,
    OrderHistoryListReq,
    OrderHistoryRes,
    OrderSummaryReq,
    OrderSummaryRes,
    PAYMENT_TYPE_FILTER,
    PAYMENT_TYPE_FILTER_SUCCESS,
    PaymentTypeFilter,
    PRODUCT_TYPE_FILTER,
    PRODUCT_TYPE_FILTER_SUCCESS,
    ProductTypeFilter,
    TRANSACTION_TYPE_FILTER,
    TRANSACTION_TYPE_FILTER_SUCCESS,
    TransactionTypeFilter
} from "../types/orderManagement";

export const getOrderEntryInvestorList =
    (body: GetOrderEntryInvestorListRequestBody) =>
        async (dispatch: any): Promise<GetOrderEntryInvestorListResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/applications/orderEntryInvestorList`,
                    method: 'POST',
                    types: [GET_ORDER_ENTRY_INVESTOR_LIST_SUCCESS, GET_ORDER_ENTRY_INVESTOR_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const addOrderEntry =
    (body: AddOrderEntryRequestBody) =>
        async (dispatch: any): Promise<AddOrderEntryResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/orderEntry`,
                    method: 'POST',
                    types: [ADD_ORDER_ENTRY_SUCCESS, ADD_ORDER_ENTRY],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getProductTypeFilter =
    () =>
        async (dispatch: any): Promise<ProductTypeFilter> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/nonMfTransactions/getProductFilter',
                    method: 'GET',
                    types: [PRODUCT_TYPE_FILTER_SUCCESS, PRODUCT_TYPE_FILTER],
                },
            });
        };

export const getTransactionTypeFilter =
    () =>
        async (dispatch: any): Promise<TransactionTypeFilter> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/nonMfTransactions/getTransactionTypeFilter',
                    method: 'GET',
                    types: [TRANSACTION_TYPE_FILTER_SUCCESS, TRANSACTION_TYPE_FILTER],
                },
            });
        };

export const getPaymentTypeFilter =
    () =>
        async (dispatch: any): Promise<PaymentTypeFilter> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/nonMfTransactions/getPaymentStatusFilter',
                    method: 'GET',
                    types: [PAYMENT_TYPE_FILTER_SUCCESS, PAYMENT_TYPE_FILTER],
                },
            });
        };

export const getApprovalTypeFilter =
    () =>
        async (dispatch: any): Promise<PaymentTypeFilter> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/nonMfTransactions/getApprovalStatusFilter',
                    method: 'GET',
                    types: [APPROVAL_TYPE_FILTER_SUCCESS, APPROVAL_TYPE_FILTER],
                },
            });
        };

export const getOrderHistoryList =
    (body: OrderHistoryListReq) =>
        async (dispatch: any): Promise<OrderHistoryRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/ordersList`,
                    method: 'POST',
                    types: [ORDER_HISTORY_LIST_SUCCESS, ORDER_HISTORY_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getOrderStatusForOrderHistory =
    (body: { id: number | string, product: string, productOrderId: string | number }) =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/getOrderStatus`,
                    method: 'POST',
                    types: [ORDER_STATUS_SUCCESS, ORDER_STATUS],
                    body,
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };



export const getOrderSummary =
    (body: OrderSummaryReq) =>
        async (dispatch: any): Promise<Array<OrderSummaryRes>> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/orderSummary`,
                    method: 'POST',
                    types: [ORDER_SUMMARY_SUCCESS, ORDER_SUMMARY],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getOrderEntryBanksList =
    (body: GetOrderEntryBanksListRequestBody) =>
        async (dispatch: any): Promise<GetOrderEntryBanksListResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/applications/orderEntryBanksList`,
                    method: 'POST',
                    types: [GET_ORDER_ENTRY_BANKS_LIST_SUCCESS, GET_ORDER_ENTRY_BANKS_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getNonMfSecuritiesList =
    (body: GetNonMfSecuritiesListRequestBody) =>
        async (dispatch: any): Promise<Record<string, any>> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/nonMfSecurityList`,
                    method: 'POST',
                    types: [GET_NON_MF_SECURITIES_LIST_SUCCESS, GET_NON_MF_SECURITIES_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getNonMfHoldingsList =
    (body: GetNonMfHoldingsListRequestBody) =>
        async (dispatch: any): Promise<Record<string, any>> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/nonMfHoldingsList`,
                    method: 'POST',
                    types: [GET_NON_MF_HOLDINGS_LIST_SUCCESS, GET_NON_MF_HOLDINGS_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getNonMfBrokersList =
    (body: GetNonMfBrokersListRequestBody) =>
        async (dispatch: any): Promise<GetNonMfBrokersListResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/brokersList`,
                    method: 'POST',
                    types: [GET_NON_MF_BROKERS_LIST_SUCCESS, GET_NON_MF_BROKERS_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getBondsDpId =
    (body: GetBondsDpIdRequestBody) =>
        async (dispatch: any): Promise<GetBondsDpIdResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/applications/dpId`,
                    method: 'POST',
                    types: [GET_BONDS_DP_ID_SUCCESS, GET_BONDS_DP_ID],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getSettlementDetails =
    (body: GetSettlementDetailsRequestBody) =>
        async (dispatch: any): Promise<GetSettlementDetailsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/settlementBankDetails`,
                    method: 'POST',
                    types: [GET_SETTLEMENT_DETAILS_SUCCESS, GET_SETTLEMENT_DETAILS],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getCounterPartyList =
    (body: GetCounterPartyListRequestBody) =>
        async (dispatch: any): Promise<GetCounterPartyListResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/counterPartyList`,
                    method: 'POST',
                    types: [GET_COUNTER_PARTY_LIST_SUCCESS, GET_COUNTER_PARTY_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getTradeCalculation =
    (body: GetTradeCalculationRequestBody) =>
        async (dispatch: any): Promise<GetTradeCalculationResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/tradeCalculation`,
                    method: 'POST',
                    types: [GET_TRADE_CALCULATION_SUCCESS, GET_TRADE_CALCULATION],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getBankBalance =
    (body: GetBankBalanceRequestBody) =>
        async (dispatch: any): Promise<GetBankBalanceResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/bse-star/icici-fetch-balance`,
                    method: 'POST',
                    types: [GET_BANK_BALANCE_SUCCESS, GET_BANK_BALANCE],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getBrokerBankDetails =
    (body: GetBrokerBankDetailsRequestBody) =>
        async (dispatch: any): Promise<GetBrokerBankDetailsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/brokerBankDetails`,
                    method: 'POST',
                    types: [GET_BROKER_BANK_DETAILS_SUCCESS, GET_BROKER_BANK_DETAILS],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getDematDetails =
    (body: GetDematDetailsRequestBody) =>
        async (dispatch: any): Promise<GetDematDetailsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/onboarding/get-demat-details',
                    method: 'POST',
                    types: [GET_DEMAT_DETAILS_SUCCESS, GET_DEMAT_DETAILS],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };
